module.exports = __webpack_public_path__ + "static/media/Icon-dwelling-copy.02ef6f0a.svg";